import { useApiQuery } from "../../../api/useApi";

export interface UnreadConversationsCountResponse {
    unread_conversations_count: number;
}

/**
 * Hook pour récupérer le nombre de conversations non lues
 * Utilisé pour afficher le badge dans la sidebar
 *
 * @param facilityId - ID de l'établissement
 * @param enabled - Active/désactive le fetching
 */
export function useUnreadConversationsCount(facilityId?: number, enabled: boolean = true) {
    // Ne jamais faire de requête sans facility_id pour éviter d'obtenir les données du groupe par défaut
    const url = facilityId
        ? `/unread-conversations-count?facility_id=${facilityId}`
        : '';

    const result = useApiQuery<UnreadConversationsCountResponse>(
        url,
        {},
        {
            enabled: enabled && facilityId !== undefined && facilityId > 0 && url !== '',
            staleTime: 0, // Toujours considéré stale → invalidation = refetch immédiat
            refetchOnWindowFocus: false, // Ne pas refetch quand on revient sur l'onglet
            retry: false, // Ne pas réessayer sur erreur (évite les 403 répétés)
    }
    );

    return result;
}
